import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import EditIcon from '@mui/icons-material/Edit';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

import UserService from '../services/user.service';

export default function UserEditModal() {
  // States / Form Fields
  const currentUser = JSON.parse(localStorage.getItem("user-data"));

  // Modal
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Form fields
  const [firstname, setFirstname] = React.useState(currentUser.firstname || "");
  const [lastname, setLastname] = React.useState(currentUser.lastname || "");
  const [phone, setPhone] = React.useState(currentUser.phone || "");
  const [email, setEmail] = React.useState(currentUser.email || "");
  const [mobile, setMobile] = React.useState(currentUser.mobile || "");
  const [adress, setAdress] = React.useState(currentUser.adresse || "");
  const [zip, setZip] = React.useState(currentUser.zip || "");
  const [ort, setOrt] = React.useState(currentUser.ort || "");

  const [isFormSuccess, setIsFormSuccess] = React.useState(false);
  const successMessage = (
    <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
      Das Formular wurde erfolgreich abgeschickt. Vielen Dank!
    </Alert>
  );

  // Event handling
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFormSuccess(true);
    await UserService.updateUser(firstname, lastname, phone, email, mobile, adress, zip, ort);
    setTimeout(() => {
      navigate('/dashboard');
      window.location.reload();
    }, 2500);
  };

  // Modal styling
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: '8px',
    p: 4,
    width: '100%',
    maxWidth: 600,
  };

  return (
    <div>
      <EditIcon onClick={handleOpen} sx={{ float: 'right', cursor: 'pointer' }} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Container sx={style}>
          <Typography variant="h6" align="center">
            Ihre Daten ändern
          </Typography>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Grid container mt={3} rowSpacing={2} columnSpacing={2} justifyContent="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Name"
                  variant="outlined"
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Nachname"
                  variant="outlined"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Telefon"
                  variant="outlined"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  required
                  label="E-Mail"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Mobil"
                  variant="outlined"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  required
                  label="Adresse"
                  variant="outlined"
                  value={adress}
                  onChange={(e) => setAdress(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  required
                  label="PLZ"
                  variant="outlined"
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  required
                  label="Ort"
                  variant="outlined"
                  value={ort}
                  onChange={(e) => setOrt(e.target.value)}
                />
              </Grid>
            </Grid>
            <Box mt={4} textAlign="center">
              <Button type="submit" variant="contained" color="primary">
                Speichern
              </Button>
            </Box>
          </form>
          <Box mt={4}>
            {isFormSuccess ? successMessage : ''}
          </Box>
        </Container>
      </Modal>
    </div>
  );
}
